import { MdCheckCircle, MdDelete } from 'react-icons/md';
import {
  Button,
  Icon,
  Modal,
  ModalFooter,
  useToastNotifications,
} from '@nbirl/nbi-common-ui-libs';

import { useErrorToast } from '../../../../../shared/hooks';
import { Folder } from '../../models';
import { useDeleteFolderMutation } from '../../queries';

type DeleteFolderProps = {
  isOpen: boolean;
  selectedFolder: Folder;
  onSuccess: () => void;
  onCloseModal: () => void;
};

export const DeleteFolderModal = ({
  isOpen,
  selectedFolder,
  onSuccess,
  onCloseModal,
}: DeleteFolderProps) => {
  const { addToast } = useToastNotifications();
  const { showErrorToast } = useErrorToast();
  const deleteFolderMutation = useDeleteFolderMutation();

  const handleDeleteFolder = () => {
    onCloseModal();
    deleteFolderMutation.mutate(selectedFolder.id, {
      onSuccess: () => {
        addToast({
          variant: 'success',
          text: 'The folder was successfully deleted.',
          icon: MdCheckCircle,
        });
        onSuccess();
      },
      onError: () => {
        showErrorToast(
          'Something went wrong. The folder could not be deleted.'
        );
      },
    });
  };

  return (
    <Modal
      heading="Delete Folder?"
      headingIcon={<Icon icon={<MdDelete />} />}
      isOpen={isOpen}
      onDismiss={onCloseModal}
    >
      Are you sure you want to delete this folder and all of its contents? This
      folder will not be recoverable once deleted.
      <ModalFooter>
        <Button variant="outline" onClick={onCloseModal}>
          No, cancel
        </Button>

        <Button onClick={handleDeleteFolder}>Yes, delete</Button>
      </ModalFooter>
    </Modal>
  );
};
